import { createTheme } from '@mui/material/styles'

export const defaulTheme = createTheme({
  palette: {
    primary: {
      main: '#0067A5' // blue-500
    }
  },
  components: {
    MuiFormControl: {
      defaultProps: {
        variant: 'filled'
      }
    },
    MuiTextField: {
      defaultProps: {
        variant: 'filled'
      }
    },
    MuiFormControlLabel: {
      styleOverrides: {
        root: {
          color: 'var(--grey-700)'
        }
      }
    },
    MuiFormLabel: {
      styleOverrides: {
        asterisk: {
          display: 'none'
        },
        root: {
          color: 'var(--grey-700)'
        }
      }
    },
    MuiTooltip: {
      defaultProps: {
        componentsProps: {
          tooltip: {
            sx: { backgroundColor: 'var(--grey-900)' }
          }
        }
      }
    },
    MuiFilledInput: {
      defaultProps: {
        disableUnderline: true
      },
      styleOverrides: {
        root: {
          border: '1px solid var(--border)',
          borderBottomLeftRadius: '4px',
          borderBottomRightRadius: '4px',
          backgroundColor: 'var(--white)',
          '&:hover': {
            backgroundColor: 'var(--white)',
            border: '1px solid var(--black)'
          },
          '&.Mui-focused': {
            backgroundColor: 'var(--white)',
            border: '2px solid var(--blue-300)'
          }
        }
      }
    },
    MuiLinearProgress: {
      styleOverrides: {
        root: {
          '& .MuiLinearProgress-barColorPrimary': {
            backgroundColor: 'var(--blue-700)'
          }
        }
      }
    },
    MuiTabs: {
      defaultProps: {
        indicatorColor: 'primary'
      }
    },
    MuiTab: {
      styleOverrides: {
        root: {
          fontFamily: 'Raleway',
          fontSize: '14px',
          fontWeight: 400,
          '&.Mui-selected': {
            fontWeight: 600
          }
        }
      }
    },
    MuiTypography: {
      defaultProps: { component: 'p' },
      variants: [
        {
          props: { variant: 'h1' }, /* component props */
          style: {
            fontSize: '36px',
            fontFamily: 'Raleway',
            color: 'var(--grey-900)',
            fontWeight: 800
          }
        },
        {
          props: { variant: 'h2' },
          style: {
            fontSize: '28px',
            fontFamily: 'Raleway',
            color: 'var(--grey-900)',
            fontWeight: 700
          }
        },
        {
          props: { variant: 'h3' },
          style: {
            fontSize: '24px',
            fontFamily: 'Raleway',
            color: 'var(--grey-900)',
            fontWeight: 700
          }
        },
        {
          props: { variant: 'h4' },
          style: {
            fontSize: '20px',
            fontFamily: 'Raleway',
            color: 'var(--grey-900)',
            fontWeight: 500
          }
        },
        {
          props: { variant: 'h5' },
          style: {
            fontSize: '16px',
            fontFamily: 'Raleway',
            color: 'var(--grey-900)',
            fontWeight: 600
          }
        },
        {
          props: { variant: 'body1' },
          style: {
            fontSize: '14px',
            fontFamily: 'Open Sans',
            color: 'var(--grey-900)',
            fontWeight: 400
          }
        },
        {
          props: { variant: 'body2' },
          style: {
            fontSize: '12px',
            fontFamily: 'Open Sans',
            color: 'var(--grey-900)',
            fontWeight: 400
          }
        },
        {
          props: { variant: 'subtitle1' },
          style: {
            fontSize: '12px',
            fontFamily: 'Open Sans',
            color: 'var(--grey-900)',
            fontWeight: 600
          }
        }
      ]
    },
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          fontFamily: 'Open Sans'
        }
      }
    }
  }
})
